module.exports = __webpack_public_path__ + "static/media/R-Smart Max.29d806a3.jpg";